<template>
    <div>
        <Select title="Conta Bancária" field="bankAccount" :formName="formName" :required="true"
            v-model="obj.bankAccount" url="api/v1/financial/bank-account/select-all-open-finance"
            nameNewRegister="connectOpenFinanceAccount" titleNewRegister="Conectar Conta ao Open Finance"
            labelNewRegister="Conectar" :widthNewRegister="500" :heightNewRegister="300">
            <ConnectOpenFinanceAccount v-model="obj.bankAccount" />
        </Select>
        <b-row>
            <b-col sm="6">
                <DateTime title="Data Inicio" field="dateFrom" :formName="formName" format="DD/MM/YYYY" type="date"
                    placeholder :required="true" v-model="obj.dateFrom" />
            </b-col>
            <b-col sm="6">
                <DateTime title="Data Fim" field="dateTo" :formName="formName" format="DD/MM/YYYY" type="date"
                    placeholder :required="true" v-model="obj.dateTo" />
            </b-col>
        </b-row>
        <div class="text-center">
            <Button _key="btnExecuteImport" :disabled="disabled" title="Importar" backGroundColor="#0A36DB"
                color="white" size="small" :clicked="executeImport" />
        </div>
    </div>
</template>
<script>

import Button from "@/ui/forms/Button";
import DateTime from "@/ui/forms/DateTime";
import Select from "@/ui/forms/Select";
import ConnectOpenFinanceAccount from "../bankAccount/ConnectOpenFinanceAccount";
import BankReconciliationService from "../../services/bankReconciliation.service";

import { mapActions, mapMutations } from "vuex";

export default {
    name: "ImportPluggy",
    components: {
        Button,
        DateTime,
        Select,
        ConnectOpenFinanceAccount
    },
    data() {
        return {
            formName: "importPluggyForm",
            obj: {
                bankAccount: {},
                dateFrom: "",
                dateTo: "",
            },
        }
    },
    computed: {
        disabled() {
            if (!this.obj.bankAccount.id || this.obj.dateFrom == "" || this.obj.dateTo == "") return true;
            return false;
        }
    },
    methods: {
        ...mapActions("generic", ["postApi"]),
        ...mapMutations("generic", ["addEvent", "hideModal", "removeLoading"]),
        executeImport() {
            let params = {
                url: BankReconciliationService.urlImportOpenFinance, obj: {
                    bankAccountId: this.obj.bankAccount.id,
                    dateFrom: this.obj.dateFrom,
                    dateTo: this.obj.dateTo
                }
            };
            this.postApi(params).then((response) => {
                if (response.success) {
                    this.hideModal();
                    this.addEvent({ name: "importPluggy" });
                    this.$toasted.success((response.content && response.content.imported || 0) + " transações importadas.");
                }
                this.removeLoading(["btnExecuteImport"]);
            });
        }
    }
}

</script>
